export default {
  questions: {
    items: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: ['timestamp'],
      totalItems: 0,
      rowsPerPageItems: [10, 20, 30],
      filterBy: 'unanswered',
    },
    numUnanswered: 0,
    numAnswered: 0,
    loading: false,
  },
  questionForm: {
    id: null,
    userName: null,
    userEmail: null,
    timestamp: null,
    questionText: null,
    answerText: null,
    posted: false,
    answered: false,
  },
};
